import { createFileRoute } from "@tanstack/react-router";

import { PraxaHistoryThread } from "../components/praxa/PraxaHistorySurface";

export const Route = createFileRoute("/w/$workspaceId/channels/$channelId")({
  component: PraxaChannelHistoryRoute,
});

function PraxaChannelHistoryRoute() {
  const { workspaceId, channelId } = Route.useParams();
  return (
    <PraxaHistoryThread
      selection={{ kind: "channel", workspaceId, channelId }}
      workspaceId={workspaceId}
    />
  );
}
